import $ from "jquery";
import jQuery from "jquery";
import filter_form from './modules/filter-form/index';
import { PackageSelector } from './modules/package-selector';

require('./modules/taxatiemodule');

// export for others scripts to use
window.$ = $;
window.jQuery = jQuery;

require('./assets');
require('swiper/dist/js/swiper.jquery');
require('video.js');
require('bootstrap/dist/js/bootstrap');

require('jquery-ui');
require('jquery-ui/ui/effect');

// set CSRF token for every AJAX request using jquery.cookie
require('jquery.cookie');
$.ajaxSetup({headers: {'X-XSRF-TOKEN': $.cookie('XSRF-TOKEN')}});

var navLocked = false;

// $('.datepicker').pickadate();
import {FormValidation} from "./modules/FormValidation";

let forms = document.getElementsByClassName('form-validation');
for (let i = 0; i < forms.length; i++) {
	let form = forms[i];
	let $form = $(form);

	let t = new FormValidation($form, {
		inputGroup: 'input',
		invalidClass: 'error',
		loading: '<i class="fa fa-spinner fa-spin mx-auto"></i>',
		button: form.querySelector('input[type="submit"]'),
		error: 'X',
		onSubmitSuccess: (res) => {
			let beforeElement = $form.find('.before-submit');
			let afterElement = $form.find('.after-submit');
			if (res.hasOwnProperty('success')) {
				beforeElement.hide();
				afterElement.html(res.success);
				afterElement.show();
			}
		},
		onSubmitFailed: (r) => {
			if (r.hasOwnProperty('errors')) {
				t.showErrors(r.errors);
			}
		},
	});
}

import {RecaptchaManager} from './modules/recaptcha';

new RecaptchaManager();

let closePopupEl = document.querySelectorAll('[data-popup-close]');
let popup = document.querySelector('.popup');
if (closePopupEl && popup) {
	function closePopup() {
		popup.style.display = 'none';
	}

	for (let i = 0; i < closePopupEl.length; i++) {
		let closer = closePopupEl[i];
		closer.addEventListener('click', closePopup);
	}
}

$(function () {

	// Package selector for occasion detail page
	new PackageSelector();

	// Navigation
	$('.nav-mobile').on('click', function () {
		//$('body').css('overflow', 'hidden');
		$('.nav-main').addClass('visible');
	});

	$('.nav-main > .close-menu').on('click', function () {
		//$('body').css('overflow', 'auto');
		$('.nav-main').removeClass('visible');
	});

	$('.nav-main ul li a[data-drop]').on('click', function () {
		var drop = $(this).data('drop');
		$('.nav-drop').removeClass('visible');

		if (drop && $(drop).length) {
			if ($(drop).is(':hidden')) {
				$('.nav-drop-panel').hide();
				$(drop).show();
				$('.nav-drop').addClass('visible');
			} else {
				$('.nav-drop-panel').hide();
			}

			$(window).trigger('scroll');
		}
	});

	$('.nav-drop-panel > .close-menu').on('click', function () {
		$('.nav-drop').removeClass('visible');
	});

	$('.nav-drop ul li a[data-drop-sub]').on('click', function () {
		var drop = $(this).data('drop-sub');

		if (drop) {
			$('.nav-drop-sub-panel').hide();
			$(drop).css('height', 'auto');

			var height = $(window).height() - $('nav.nav-bar').outerHeight();

			if ($(drop).outerHeight() > height) {
				$(drop).css('height', height);
			}

			$(drop).show();
			$(window).trigger('scroll');
		}
	});

	$('.nav-drop-sub-panel > .close-menu').on('click', function () {
		$('.nav-drop-sub-panel').hide();
	});

	// Carousel block
	$('.swiper-container.carousel').each(function () {

		var swiperConfig = {
			pagination: '.swiper-pagination',
			onSlideChangeStart: function (swiper) {
				swiper.container.find('.swiper-navigation a.active').removeClass('active');
				swiper.container.find('.swiper-navigation a:eq(' + swiper.activeIndex + ')').addClass('active');
			},
			spaceBetween: 1,
		};

		if ($(this).hasClass('slideshow') || $(this).hasClass('homeslider') || $(this).hasClass('gallery-top')) {
			swiperConfig.autoplay = 5000;
			swiperConfig.speed = 1000;
		}

		var carousel = $(this);
		var swiper = new Swiper(carousel, swiperConfig);

		// Navigation for carousel block
		carousel.find('.swiper-navigation a').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();

			swiper.slideTo($(this).index());

			$(this).parents('.swiper-container').find('.swiper-navigation a.active').removeClass('active');
			$(this).addClass('active');
		});

	});

	// Go to the top of the page
	$('.pageup').on('click', function () {
		$('html, body').animate({
			scrollTop: 0
		}, 500);

		return false;
	});

	// Occasions prices
	$('.calculator [name="package"]').on('change', function () {
		var value = $(this).val();
		var baseprice = $('[name="baseprice"]').val();

		$('.calculator .value').html('&euro; ' + number_format(parseInt(baseprice) + parseInt(value), 0, ',', '.'));
	});

	// Responsive accordion
	$('.occasion-detail .info h2').on('click', function () {
		$(this).closest('.info').toggleClass('active');
	});


	// Show menu when mouse is near top
	$('nav.subnav-bar').on('mouseenter', function (e) {
		if (e.clientY < 80) {
			$('body').removeClass('subnav-scroll');
		}
	});

	// Contactcenter popup

	$('.contactcenter .cc-header').on('click', function () {
		$('.contactcenter').toggleClass('active');
	});

	$('.contactcenter .switch-cc-panel').on('click', function () {
		$('.contactcenter .cc-panel.active').removeClass('active');
		$($(this).data('panel')).addClass('active');
	});

	//submitting the callme form
	$('#callme-form').on('submit', function (e) {
		e.preventDefault();
		var $form = $(this);
		var action = $(this).attr('action');

		$form.find('input[type="submit"]').prop('disabled', true);

		//$('.error-msg').remove();
		$.post(action, $(this).serialize(), function (response) {
			if (response.success) {
				$form.html('Bedankt voor uw aanvraag, we nemen zo snel mogelijk contact met u op.')
			}
		}).fail(function (r) {
			var response = r.responseJSON;
			for (var field_name in response) {
				$('input[name=' + field_name + ']').addClass('error').val(response[field_name][0]);
			}
			$form.find('input[type="submit"]').prop('disabled', false);
		});
		return false;
	});

	function lockContact($container) {
		var y = $(window).height() + $(window).scrollTop();
		if (y > $('footer').offset().top)
			$container.removeClass('transition').addClass('locked');
		else
			$container.removeClass('transition').removeClass('locked');

		setTimeout(function () {
			$container.addClass('transition');
		}, 50);
	}

	let contactcenter = $('.contactcenter');
	let buttoncenterContainer = $('.buttoncenter-container');
	let buttoncenter = $('.buttoncenter');

	setTimeout(function () {
		lockContact(contactcenter);
	}, 500);
	$(window).on('scroll', function () {
		lockContact(contactcenter);
	});
	$(window).on('resize', function () {
		lockContact(contactcenter);
	});

});

// $('#callme-form').on('submit', function (e) {
//     e.preventDefault();
//     var url = $(this).attr('action');
//     $.post(url, $(this).serialize(), function (response) {
//         for (let field_name in response) {
//             $('input[name=' + field_name + ']').addClass('error').val(response[field_name][0]);
//         }
//     });
//     ga('send', 'event', 'macro-conversie', 'formulier', 'callme-form');
//
//     return false;
// });


$('#callme-form').on('submit', function (e) {
	e.preventDefault();
	var url = $(this).attr('action');
	var $form = $(this);
	$form.find('input[type="submit"]').prop('disabled', true);
	$.post(url, $(this).serialize(), function (response) {
		if (response.success) {
			$form.html('Bedankt voor uw aanvraag, we nemen zo snel mogelijk contact met u op.')
		} else {
			$form.find('input[type="submit"]').prop('disabled', false);

			for (let field_name in response) {
				$('input[name=' + field_name + ']').addClass('error').val(response[field_name][0]);
			}
		}
	});
	ga('send', 'event', 'macro-conversie', 'formulier', 'callme-form');

	return false;
});

$('#question-form').on('submit', function (e) {
	e.preventDefault();
	var url = $(this).attr('action');
	var $form = $(this);
	$form.find('input[type="submit"]').prop('disabled', true);
	$.post(url, $(this).serialize(), function (response) {
		if (response.success) {
			$form.html('Bedankt voor uw aanvraag, we nemen zo snel mogelijk contact met u op.')
		} else {
			$form.find('input[type="submit"]').prop('disabled', false);

			if ($form.hasClass('question_form--alt')) {
				for (let field_name in response) {
					$('input[name=' + field_name + ']').addClass('error').parent().append('<div class="error-msg">' + response[field_name][0] + '</div>');
				}
			} else {
				for (let field_name in response) {
					$('input[name=' + field_name + ']').addClass('error').val(response[field_name][0]);
				}
			}
		}
	});
	ga('send', 'event', 'macro-conversie', 'formulier', 'question-form');

	return false;
});

$('#workplace-form').on('submit', function (e) {
	e.preventDefault();
	var url = $(this).attr('action');
	var $form = $(this);
	$form.find('input[type="submit"]').prop('disabled', true);
	$.post(url, $(this).serialize(), function (response) {
		if (response.success) {
			$form.html('Bedankt voor uw aanvraag, we nemen zo snel mogelijk contact met u op.')
		} else {
			$form.find('input[type="submit"]').prop('disabled', false);

			for (field_name in response) {
				$('input[name=' + field_name + ']').addClass('error').val(response[field_name][0]);
			}
		}
	});
	ga('send', 'event', 'macro-conversie', 'formulier', 'question-form');

	return false;
});


$(window).on('load', function () {

//    var myLatlng = new google.maps.LatLng(52.078638, 4.895352);
//    var mapOptions = {
//        zoom: 14,
//        center: myLatlng,
//        scrollwheel: false
//    };
//    var map = new google.maps.Map(document.getElementById('map'), mapOptions);
//
//    var marker = new google.maps.Marker({
//        position: myLatlng,
//        map: map
//    });

	// Lazy loading
	$('img[data-src]').unveil(500, function () {
		$(this).on('load', function () {
			this.style.opacity = 1;
		});
	});

});

$(window).on('scroll', function () {

	if (!navLocked) {
		// Collapse subnav
		if ($(window).scrollTop() > 10) {
			$('body').addClass('subnav-scroll');
		} else {
			$('body').removeClass('subnav-scroll');
		}
	}

});

$(function () {
	$('#leaseofferte').click(function () {
		$('#uitklap').removeClass("hidden", 600);
		$('#uitklap').css("display", "block");
	});
});

function scrollTo(elem) {
	$('html, body').animate({
		scrollTop: $(elem).offset().top
	}, 500);
}

$(function () {
	let $filters = $('.occasions-filters');

	$filters.on('submit', function (e) {
		e.stopImmediatePropagation();
	})

	filter_form($filters, {
		state: false, callback: function ($dom) {
			$dom.find('img[data-src]').unveil(500, function () {
				$(this).on('load', function () {
					this.style.opacity = 1;
				});
			});
		},
		auto: false
	});

	toggleOccasionModelField($filters);
});


require('slick-carousel');
//
$(function () {
	$('.slider-single').slick({
		nextArrow: '<div  class="slick-next">' +
			'<svg width="512" height="512" viewBox="0 0 512 512" fill="none">' +
			'<path d="M154.668 458.667L357.335 256L154.668 53.3334" stroke="white" stroke-width="21.3333" stroke-linecap="square"/>' +
			'</svg>' +
			'</div>',
		prevArrow: '<div  class="slick-prev">' +
		'<svg width="512" height="512" viewBox="0 0 512 512" fill="none">' +
		'<path d="M357.335 53.3334L154.668 256L357.335 458.667" stroke="white" stroke-width="21.3333" stroke-linecap="square"/>' +
		'</svg>' +
		'</div>',
		draggable: false,
		infinite: true,
		swipe: false,
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: '.slider-nav',
		speed: 600
	});

	$('.slider-nav').slick({
		slidesToShow: 8,
		slidesToScroll: 1,
		asNavFor: '.slider-single',
		centerMode: false,
		focusOnSelect: true,
		arrows: false
	});
});

$(function () {
	// Toggle new cars menu categories
	let parent_categories = document.querySelectorAll('[data-category-parent]');

	if (parent_categories.length) {
		for (let i = 0; i < parent_categories.length; i++) {
			let parent = parent_categories[i];

			$(parent).on('click', function (e) {
				let parent_title = document.getElementsByClassName(e.target.classList.value);
				let content = document.getElementById(e.target.dataset.categoryParent);
				let category_content = document.getElementsByClassName(content.classList.value);

				// Toggle parent category state
				removeActive(parent_title);
				addActive(e.target);

				// Toggle category content state
				removeActive(category_content);
				addActive(content);
			});

			function removeActive(elem) {
				for (let j = 0; j < elem.length; j++) {
					if (elem[j].classList.contains('active')) {
						elem[j].classList.remove('active');
					}
				}
			}

			function addActive(elem) {
				if (!elem.classList.contains('active')) {
					elem.classList.add('active');
				}
			}
		}
	}
});


function toggleOccasionModelField($filters) {
	const merk = $filters.find("select[name='merk']");
	const model = $filters.find("select[name='model']");

	if (merk.length && model.length) {
		const $merk = $(merk);
		const $model = $(model);
		const route = $model.data('route');

		if (route) {
			$merk.on('change', function (e) {
				// remove previous values & options
				$model.val('');
				$model.find('option').not(':first').remove();

				// show model field when brand is selected
				if (!$model.is(':visible')) {
					const wrapper = $model.closest('.filter');

					if (wrapper.length) {
						$(wrapper).show();
					}
				}

				$.ajax({
					type: 'post',
					data: {'merk': $merk.val()},
					url: route,
					success: function (res) {
						$.each(res, function (modelType, brand) {
							$model.append($('<option>', {
								value: modelType,
								text: modelType
							}));
						});
					},
					error: function (res) {
						console.log(res);
					}
				});
			});
		}
	}
}